import React, { useEffect, useState } from "react";
import LazyImage from "../LazyImage";
import { makeRequest } from "../../api";
import { toast } from "react-toastify";
import { successToaster, warningToaster } from "../../Data/Data";
import { Select } from "antd";

const UnableToIdentifyModal = ({
  unableToIdentifyTigers,
  setUnableToIdentifyTigers,
  unableToIdentifyTigerData,
  selectedTiger,
  setSelectedTiger,
  fetchUnidentifiedTigerImages,
  tigerslist,
  loading,
  setUnableToIdentifyModalOpen,
}) => {
  const [selectedMatchedTiger, setSelectedMatchedTiger] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const [currentTigerIndex, setCurrentTigerIndex] = useState(0);
  const [selectedListTiger, setSelectedListTiger] = useState(null);
  const [selectedListTigerName, setSelectedListTigerName] = useState("");

  useEffect(() => {
    if (unableToIdentifyTigerData.length > 0) {
      setSelectedMatchedTiger(unableToIdentifyTigerData[0]);
    }
  }, [unableToIdentifyTigerData]);

  useEffect(() => {
    if (selectedTiger && unableToIdentifyTigers.length > 0) {
      const index = unableToIdentifyTigers.findIndex(
        (tiger) => tiger.id === selectedTiger.id
      );
      if (index !== -1) {
        setCurrentTigerIndex(index);
      }
    }
  }, []);

  const handleTigerSelection = (tiger) => {
    setIsLoading(true);
    setSelectedMatchedTiger(tiger);
    setCurrentImageIndex(0);
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  };

  const handleNextImage = () => {
    if (selectedMatchedTiger) {
      setCurrentImageIndex(
        (prevIndex) => (prevIndex + 1) % selectedMatchedTiger.images.length
      );
    }
  };

  const handlePreviousImage = () => {
    if (selectedMatchedTiger) {
      setCurrentImageIndex(
        (prevIndex) =>
          (prevIndex - 1 + selectedMatchedTiger.images.length) %
          selectedMatchedTiger.images.length
      );
    }
  };

  const handleNextTiger = () => {
    if (currentTigerIndex < unableToIdentifyTigers.length - 1) {
      const nextIndex = currentTigerIndex + 1;
      setCurrentTigerIndex(nextIndex);
      const nextTiger = unableToIdentifyTigers[nextIndex];
      setSelectedTiger(nextTiger);
      fetchUnidentifiedTigerImages(nextTiger.id);
    } else {
      setUnableToIdentifyModalOpen(false);
    }
  };

  const handlePrevTiger = () => {
    if (currentTigerIndex > 0) {
      const prevIndex = currentTigerIndex - 1;
      setCurrentTigerIndex(prevIndex);
      const prevTiger = unableToIdentifyTigers[prevIndex];
      setSelectedTiger(prevTiger);
      fetchUnidentifiedTigerImages(prevTiger.id);
    }
  };

  const handleIdentify = async (imageID, tigerID, type) => {
    if (!selectedMatchedTiger || !selectedTiger) {
      toast.error(
        "Please select a matched tiger and an uploaded tiger image.",
        warningToaster
      );
      return;
    }

    try {
      let token = "";
      if (localStorage.token) {
        token = localStorage.token;
      }

      const data = {
        image_id: imageID,
        tiger_id: tigerID,
        origin: "upload",
      };

      const response = await makeRequest(
        "post",
        `api/v1/identification/tiger_identify`,
        data
      );

      if (response.data && response.data.data.success) {
        toast.success("Tiger successfully identified!", successToaster);

        const matchedTigerName =
          type === "default"
            ? selectedMatchedTiger.name
            : selectedListTigerName;
        const updatedData = unableToIdentifyTigers.map((tiger) =>
          tiger.id === selectedTiger.id
            ? { ...tiger, checked: true, species_name: matchedTigerName }
            : tiger
        );
        setUnableToIdentifyTigers(updatedData);
        handleNextTiger();
      } else {
        toast.error(
          "Failed to identify the tiger. Please try again.",
          warningToaster
        );
      }
    } catch (error) {
      console.error("Error identifying tiger:", error);
      toast.error(
        "An error occurred while identifying the tiger.",
        warningToaster
      );
    } finally {
    }
  };

  const tigerSelectionHandler = (value, option) => {
    setSelectedListTiger(value);
    setSelectedListTigerName(option.label);
  };

  return (
    <div className="tiger-card-container">
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div
          className="half"
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "1vh",
            width: "45%",
          }}
        >
          <div style={{ display: "flex", gap: "0.5vw" }}>
            <span>Uploaded Image</span>
            <span>-</span>
            <span>{selectedTiger.id}</span>
          </div>
          <LazyImage src={selectedTiger.fileName} alt={selectedTiger.id} zoomModeEnable={true} />
        </div>

        <div
          className="half"
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "1vh",
            width: "45%",
          }}
        >
          <span>
            Matching Tigers (
            {selectedMatchedTiger ? selectedMatchedTiger.name : "None"})
          </span>
          {isLoading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "200px",
                fontSize: "18px",
                fontWeight: "bold",
                color: "gray",
              }}
            >
              Loading...
            </div>
          ) : (
            selectedMatchedTiger &&
            selectedMatchedTiger.images.length > 0 && (
              <div style={{ position: "relative", textAlign: "center" }}>
                <LazyImage
                  src={selectedMatchedTiger.images[currentImageIndex]}
                  loading="lazy"
                  alt={`Tiger Image`}
                  style={{
                    width: "100%",
                    height: "auto",
                    maxHeight: "300px",
                    objectFit: "contain",
                  }}
                  zoomModeEnable={true}
                />
                <button
                  onClick={handlePreviousImage}
                  style={{
                    position: "absolute",
                    left: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    background: "rgba(0,0,0,0.5)",
                    color: "white",
                    border: "none",
                    borderRadius: "50%",
                    width: "30px",
                    height: "30px",
                    cursor: "pointer",
                  }}
                >
                  &lt;
                </button>
                <button
                  onClick={handleNextImage}
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    background: "rgba(0,0,0,0.5)",
                    color: "white",
                    border: "none",
                    borderRadius: "50%",
                    width: "30px",
                    height: "30px",
                    cursor: "pointer",
                  }}
                >
                  &gt;
                </button>
              </div>
            )
          )}
        </div>
      </div>

      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "start",
        }}
      >
        <div
          style={{
            width: "50%",
            display: "flex",
            height: "15vh",
            overflow: "auto",
            flexWrap: "wrap",
            marginTop: "2vh",
          }}
        >
          {unableToIdentifyTigerData.map((tiger) => (
            <button
              key={tiger.id}
              style={{
                opacity:
                  selectedMatchedTiger && selectedMatchedTiger.id === tiger.id
                    ? 1
                    : 0.5,
                backgroundColor: "#e67817",
                color: "white",
                margin: "5px",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
                width: "5vw",
              }}
              onClick={() => handleTigerSelection(tiger)}
            >
              {tiger.name}
            </button>
          ))}
        </div>

        <div style={{ flex: 1, marginLeft: "4vw" }}>
          <div
            style={{
              display: "flex",
              marginTop: "2vh",
              gap: "1vw",
              justifyContent: "end",
            }}
          >
            <button
              className="IdentifyButton Identified"
              onClick={() =>
                handleIdentify(
                  selectedTiger.id,
                  selectedMatchedTiger.id,
                  "default"
                )
              }
              style={{
                cursor: selectedListTiger ? "no-drop" : "pointer",
                backgroundColor: selectedListTiger ? "#C0C0C0" : undefined,
              }}
            >
              Identify
            </button>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              margin: "20px 0",
            }}
          >
            <hr
              style={{
                flex: 1,
                border: "none",
                height: "0.5px",
                backgroundColor: "grey",
              }}
            />
            <span
              style={{ margin: "0 10px", fontSize: "0.7rem", color: "#555" }}
            >
              Or
            </span>
            <hr
              style={{
                flex: 1,
                border: "none",
                height: "0.5px",
                backgroundColor: "grey",
              }}
            />
          </div>

          <p style={{ fontSize: "0.6rem" }}>
            *** Can’t identify the tiger in the list? Try selecting from the
            list of known tigers ***
          </p>
          <div
            style={{
              display: "flex",
              gap: "2vw",
              marginTop: "2.5vh",
              justifyContent: "space-between",
            }}
          >
            <div>
              <Select
                showSearch
                style={{ width: 200 }}
                placeholder="Select Tiger Name"
                optionFilterProp="children"
                size={"Medium"}
                value={selectedListTiger}
                onChange={tigerSelectionHandler}
                allowClear={true}
                loading={loading}
                filterOption={(input, option) =>
                  (option?.label ?? "").includes(input)
                }
                options={tigerslist}
              />
            </div>
            <div style={{ display: "flex", alignItems: "end" }}>
              <button
                className="IdentifyButton Identified"
                style={{
                  cursor: !selectedListTiger ? "no-drop" : "pointer",
                  backgroundColor: !selectedListTiger ? "#C0C0C0" : undefined,
                }}
                onClick={() =>
                  handleIdentify(selectedTiger.id, selectedListTiger, "list")
                }
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>

      <div style={{ marginTop: "2vh" }}>
        <div className="control-btn-container">
          <button
            disabled={currentTigerIndex === 0}
            onClick={handlePrevTiger}
            style={{
              backgroundColor: currentTigerIndex === 0 ? "#C0C0C0" : "#EDF3F2",
              cursor: currentTigerIndex === 0 ? "no-drop" : "pointer",
            }}
            className="control-btn"
          >
            Prev
          </button>
          <button
            disabled={currentTigerIndex === unableToIdentifyTigers.length - 1}
            onClick={handleNextTiger}
            style={{
              backgroundColor:
                currentTigerIndex === unableToIdentifyTigers.length - 1
                  ? "#C0C0C0"
                  : "#EDF3F2",
              cursor:
                currentTigerIndex === unableToIdentifyTigers.length - 1
                  ? "no-drop"
                  : "pointer",
            }}
            className="control-btn"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default UnableToIdentifyModal;
